import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, Validators } from '@angular/forms';
import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { Observable, takeUntil, withLatestFrom } from 'rxjs';
import { NgxsFormPluginModule } from '@ngxs/form-plugin';
import { Select, ofActionSuccessful } from '@ngxs/store';

import { NgxsActionName, NgxsFormPath, SelectItems } from '@app/shared/constants';
import { AngularMaterialModule } from '@app/shared/modules/angular-material.module';
import * as AppDataAction from '@app/shared/actions/app-data.action';
import { AppDataState } from '@app/shared/stores/app-data.state';
import { SpinnerButtonComponent } from '@shared/components/spinner-button/spinner-button.component';
import { InjectDialogData } from '@shared/components/edit-modal-dialog/edit-modal-dialog.constant';
import { WebApiResponseBase } from '@app/shared/classes/general';
import { EditModalDialogBasedComponent } from '@shared/components/edit-modal-dialog/edit-modal-dialog.based.component';
import { DrivingBehavior } from '@app/shared/classes/driving-behavior';

@Component({
  selector: 'app-driving-behavior-edit-modal-dialog',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, SpinnerButtonComponent, TranslateModule, NgxsFormPluginModule, ReactiveFormsModule, MatDialogModule, AngularMaterialModule],
  templateUrl: './driving-behavior-edit-modal-dialog.component.html',
  styleUrl: './driving-behavior-edit-modal-dialog.component.css'
})
export class DrivingBehaviorEditModalDialogComponent extends EditModalDialogBasedComponent<DrivingBehaviorEditModalDialogComponent, DrivingBehavior> {
  complianceSelectItems = SelectItems.complianceSelectItems;
  formPath = NgxsFormPath.KPI_DRIVING_BEHAVIOR_EDIT_FORM;

  @Select(AppDataState.taskExecuting(NgxsActionName.UPDATE_KPI_DRIVING_BEHAVIOR)) updating$: Observable<boolean>;
  @Select(AppDataState.taskError(NgxsActionName.UPDATE_KPI_DRIVING_BEHAVIOR)) response$: Observable<WebApiResponseBase>;

  constructor(public dialogRef: MatDialogRef<DrivingBehaviorEditModalDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: InjectDialogData<DrivingBehavior>) {
    super();
    this.dataInit(dialogRef, data);
    this.initForm(data);
  }

  initForm = (data: InjectDialogData<DrivingBehavior>) => {
    this.editForm = this.formBuilder.group({
      compliance: [data.data.compliance, Validators.required],
      description: [data.data.description]
    });
  }

  override ngOnInit() {
    super.ngOnInit();
    this.actions$.pipe(ofActionSuccessful(AppDataAction.UpdateKpiDrivingBehavior), withLatestFrom(this.response$), takeUntil(this.destroy$)).subscribe(
      ([_, errorResponse]) => this.processAfterUpdateObject(errorResponse));
  }

  onOkClick = () => {
    this.store.dispatch(new AppDataAction.UpdateKpiDrivingBehavior(this.data.data));
  }
}
